export default "__VITE_ASSET__e161b3df__"